import Swiper from 'swiper/dist/js/swiper';
import { CLASSES } from '../_consts';

export default function productsSlider(wrapper) {

  const { isActive } = CLASSES;
  const mainSliderEl = wrapper.querySelector('.js-products-slider');
  const scrollbar = wrapper.querySelector('.js-products-slider-scrollbar');
  const prev = wrapper.querySelector('.js-swiper-button-prev');
  const next = wrapper.querySelector('.js-swiper-button-next');
  const $filterWrapper = $(wrapper).find('.js-products-filter-wrapper');
  const slideSelector = '.product-thumb';

  const slider = new Swiper(mainSliderEl, {
    init: false,
    slidesPerView: 4,
    spaceBetween: 28,
    slidesPerGroup: 4,
    grabCursor: true,
    speed: 800,
    loop: false,
    threshold: 3,
    watchSlidesVisibility: true,
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
    navigation: {
      nextEl: next,
      prevEl: prev,
    },
    lazy: {
      loadPrevNext: true,
    },
    breakpoints: {
      1023: {
        slidesPerGroup: 5,
        slidesPerView: 5
      },
      950: {
        slidesPerGroup: 4,
        slidesPerView: 4
      },
      767: {
        slidesPerGroup: 3,
        slidesPerView: 3
      },
      599: {
        slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 40,
      }
    },
    // https://stackoverflow.com/questions/43770106/swiper-slider-not-working-unless-page-is-resized
    // these two settings were enough to solve the problem
    observer: true,
    observeParents: true,
  });

  slider.init();


  if ($filterWrapper.length) {
    const $button = $filterWrapper.find('.js-products-filter');

    $button.on('click', (e) => {
      const $target = $(e.currentTarget);
      const category = $target.data('filter');
      const $allSlides = $(wrapper).find(slideSelector);

      const selects = $allSlides.filter((i, el) => $(el).data('category') === category);

      if (category !== 'all') {
        $allSlides.hide();
        selects.show();
      } else {
        $allSlides.show();
      }

      slider.update();
      slider.lazy.load();

      // slide to first visible slide in filtered row
      let firstVisible = $(wrapper).find('.product-thumb:visible').eq(0);
      let reinitIndex = $allSlides.index(firstVisible);
      slider.setTranslate(0);
      slider.slideTo(reinitIndex, 0, false);

      // fix for scrollbar calculations
      setTimeout(() => {
        firstVisible = $(wrapper).find('.product-thumb:visible').eq(0);
        reinitIndex = $allSlides.index(firstVisible);
        slider.slideTo(reinitIndex, 0, false);
        slider.setTranslate(0);
      }, 100);

      $(e.currentTarget).addClass(isActive).siblings().removeClass(isActive);
    });
  }
};

